const cssVisitorKeys = {
  CssAnPlusB: [],
  CssAtrule: ["prelude", "block"],
  CssAtrulePrelude: ["children"],
  CssAttributeSelector: ["name", "value"],
  CssBlock: ["children"],
  CssBrackets: ["children"],
  CssCDC: [],
  CssCDO: [],
  CssClassSelector: [],
  CssCombinator: [],
  CssCondition: ["children"],
  CssDeclaration: ["value"],
  CssDeclarationList: ["children"],
  CssDimension: [],
  CssFeature: ["value"],
  CssFeatureFunction: ["value"],
  CssFeatureRange: ["left", "middle", "right"],
  CssFunction: ["children"],
  CssGeneralEnclosed: ["children"],
  CssHash: [],
  CssIdSelector: [],
  CssIdentifier: [],
  CssLayer: [],
  CssLayerList: ["children"],
  CssMediaQuery: ["condition"],
  CssMediaQueryList: ["children"],
  CssNestingSelector: [],
  CssNth: ["nth", "selector"],
  CssNumber: [],
  CssOperator: [],
  CssParentheses: ["children"],
  CssPercentage: [],
  CssPseudoClassSelector: ["children"],
  CssPseudoElementSelector: ["children"],
  CssRatio: ["left", "right"],
  CssRaw: [],
  CssRule: ["prelude", "block"],
  CssScope: ["root", "limit"],
  CssSelector: ["children"],
  CssSelectorList: ["children"],
  CssString: [],
  CssStyleSheet: ["children"],
  CssSupportsDeclaration: ["declaration"],
  CssTypeSelector: [],
  CssUnicodeRange: [],
  CssUrl: [],
  CssValue: ["children"],
  CssWhiteSpace: [],
};
module.exports = {
  cssVisitorKeys,
};
